import React from 'react';
import MediaFrame from '../components/MediaFrame';
import { backgroundOverlay, backgroundStyle, backgroundValue, cleanHtml, youtubeId } from '../utils/presentation';

export default function IntroWithVideo({ module }) {
  const data = module.data || {};
  const video = youtubeId(data.video);
  const style = { ...backgroundStyle(backgroundValue(data, 'selectablebg'), { size: data.backgroundSize || 'cover', position: data.backgroundPosition || 'center', tileSize: data.backgroundTileSize }), backgroundColor: data.backgroundColor || '#2a1c0f', '--section-overlay': backgroundOverlay(data, 35) };
  return (
    <section className="set-presentation-section set-media-story" style={style}>
      <div className="set-presentation-shade" />
      <div className="container set-media-story-inner">
        <div className={`row align-items-center g-4 g-lg-5 ${data.mediaPosition === 'right' ? 'flex-row-reverse' : ''}`}>
          <div className="col-lg-7">
            <MediaFrame type={data.mediaFrame}><div className="set-video-frame">{video ? <iframe title={data.title || 'Set video'} src={`https://www.youtube-nocookie.com/embed/${video}`} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /> : <div className="set-media-placeholder">Add a YouTube link or video ID</div>}</div></MediaFrame>
          </div>
          <div className="col-lg-5 set-media-story-copy">
            {data.eyebrow && <span className="set-presentation-eyebrow">{data.eyebrow}</span>}
            {data.title && <h2>{data.title}</h2>}
            {data.content && <div className="set-presentation-copy" dangerouslySetInnerHTML={{ __html: cleanHtml(data.content) }} />}
          </div>
        </div>
      </div>
    </section>
  );
}
